import { getEl } from '../../core/dom.js';
import { ownerChatClearPendingPhoto } from './attach.js';
import { ownerChatInputEl } from './dom.js';
import { syncOwnerChatInputHeight } from './composer-input.js';

const ownerChatEditBarEl = getEl('owner-chat-edit-bar');
const ownerChatEditCancelBtn = getEl('owner-chat-edit-cancel');

let ownerChatEditingMessageId: string | null = null;

export function getOwnerChatEditingMessageId(): string | null {
  return ownerChatEditingMessageId;
}

function setEditBarVisible(visible: boolean) {
  if (!ownerChatEditBarEl) return;
  ownerChatEditBarEl.hidden = !visible;
  ownerChatEditBarEl.setAttribute('aria-hidden', visible ? 'false' : 'true');
  ownerChatEditBarEl.classList.toggle('chat-edit-bar--visible', visible);
}

export function cancelOwnerChatEdit(): void {
  ownerChatEditingMessageId = null;
  setEditBarVisible(false);
  if (ownerChatInputEl) {
    ownerChatInputEl.value = '';
    syncOwnerChatInputHeight();
  }
}

export function startOwnerChatEdit(messageId: string, text: string): void {
  const id = String(messageId || '').trim();
  if (!id || id === 'consult-welcome') return;

  ownerChatClearPendingPhoto(true);
  ownerChatEditingMessageId = id;
  setEditBarVisible(true);

  if (ownerChatInputEl) {
    ownerChatInputEl.value = String(text || '');
    syncOwnerChatInputHeight();
    try {
      ownerChatInputEl.focus();
      const len = ownerChatInputEl.value.length;
      ownerChatInputEl.setSelectionRange(len, len);
    } catch (_) {}
  }
}

if (ownerChatEditCancelBtn) {
  ownerChatEditCancelBtn.addEventListener('click', function () {
    cancelOwnerChatEdit();
  });
}
